import { flexCenter } from "@components/mixins";
import React from "react";
import styled from "styled-components";

const SpinnerContainer = styled.div`
    ${flexCenter};
    width: 100%;
    max-width: 300px;
    margin: 0 auto;
    color: ${({ theme }) => theme.colors.black};
    font-weight: ${({ theme }) => theme.fw.semiBold};
    animation: 1s spin infinite both;

    i {
        font-size: ${({ theme }) => theme.fz.XXL};
    }

    @keyframes spin {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;

const SpinnerComponent = (props) => (
    <SpinnerContainer>
        <i className="fas fa-circle-notch"></i>
    </SpinnerContainer>
);

export default SpinnerComponent;
